import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBack = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.00003 16L6.59684 17.4L0.58245 11.4084C-0.195548 10.6296 -0.193948 9.36481 0.58605 8.58921L6.59684 2.60001L8.00003 4.00041L2.99878 9.00001H20V11H2.98202L8.00003 16ZM2.00005 10.0216V9.99841L1.98845 10.01L2.00005 10.0216Z",
		fill: "#FE8769"
	})
});
const ForwardRef = forwardRef(SvgBack);
export default ForwardRef;
